module.exports = __webpack_public_path__ + "img/cart_relay_marker.f392df43.svg";